// Theme (light | dark) — persisted per device in localStorage.
// Applied by toggling the `.dark` class on <html>.
import { useEffect, useState, useCallback } from "react";

const KEY = "gc.theme.v1";
const VALID = ["light", "dark"];

function systemPref() {
  if (typeof window === "undefined" || !window.matchMedia) return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function readTheme() {
  try {
    const v = localStorage.getItem(KEY);
    if (VALID.includes(v)) return v;
  } catch { /* ignore */ }
  return systemPref();
}

export function applyTheme(theme) {
  const root = document.documentElement;
  root.classList.remove("dark", "light");
  root.classList.add(theme);
  root.style.colorScheme = theme;
}

export function useTheme() {
  const [theme, setTheme] = useState(readTheme);

  useEffect(() => {
    applyTheme(theme);
    try { localStorage.setItem(KEY, theme); } catch { /* ignore */ }
  }, [theme]);

  const toggle = useCallback(() => setTheme((t) => (t === "dark" ? "light" : "dark")), []);
  return { theme, setTheme, toggle };
}

// Apply the persisted theme immediately on module load (before React mounts)
// so we don't flash the wrong colors.
if (typeof document !== "undefined") {
  applyTheme(readTheme());
}
